import { render, staticRenderFns } from "./rsvp_attendees.vue?vue&type=template&id=6578bc41"
import script from "./rsvp_attendees.vue?vue&type=script&lang=js"
export * from "./rsvp_attendees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports